"use client";
import React from "react";

export default function Error({ error, reset }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white dark:bg-[#020817] px-4">
      <h1 className="text-5xl font-bold text-red-600 mb-4">Something went wrong</h1>
      <p className="text-xl text-gray-700 dark:text-gray-300 mb-8 text-center max-w-xl">
        {error?.message || "An unexpected error occurred. Please try again later."}
      </p>
      <button
        onClick={() => reset()}
        className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition text-lg font-semibold mb-4"
      >
        Try Again
      </button>
      <a href="/" className="text-blue-600 underline text-lg">Go Home</a>
    </div>
  );
} 